import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const dfirIris = defineConnector({
  identifier: "dfirIris",
  name: "DFIR IRIS",
  tagLine: "Incident response platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your DFIR IRIS instance, go to **My Settings → API Key** and copy your API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "baseUrl",
          label: "Instance URL",
          required: true,
          target: { kind: "configuration", field: "baseUrl" },
          placeholder: "https://iris.example.com",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/ping`,
  },
});
